import { mapVariantToColor } from './styled';

export default mapVariantToColor;
